// components/EmployeeReport/EmployeeReport.js
import { useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import SiteVisitReport from "./SiteVisitReport";

export default function EmployeeReport() {
  const [key, setKey] = useState("site_visit");

  return (
    <div
      className="underline-tabs"
      style={{ paddingTop: "16px", paddingLeft: "16px", paddingRight: "16px" }}
    >
      <Tabs
        id="employee-report-tabs"
        activeKey={key}
        onSelect={(k) => setKey(k)}
        className="flex-nowrap"
      >
        <Tab eventKey="site_visit" title="Site Visit Report">
          <SiteVisitReport />
        </Tab>
      </Tabs>
    </div>
  );
}
